import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import UnlockOutlinedSvg from "@ant-design/icons-svg/es/asn/UnlockOutlined";
import AntdIcon from "../components/AntdIcon";
var UnlockOutlined = function UnlockOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UnlockOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  UnlockOutlined.displayName = 'UnlockOutlined';
}
export default /*#__PURE__*/React.forwardRef(UnlockOutlined);